import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/takeoffPilot")({
  component: TakeoffPilotLayout,
});

function TakeoffPilotLayout() {
  return <Outlet />;
}
